import { DEFAULT_LANGUAGE, type Language } from '@faceup/utils'

/**
 * Module-level store for the language sent in GraphQL request headers, mirroring
 * the `region` singleton in utils/useRegion. The Apollo client is built once per
 * session and reads this at request time, so a language change updates headers
 * (and WS connection params) without rebuilding the client or wiping the cache.
 * LanguageProvider keeps it in sync via setRequestLanguage.
 */
let requestLanguage: Language = DEFAULT_LANGUAGE

export const getRequestLanguage = () => requestLanguage

export const setRequestLanguage = (language: Language) => {
  requestLanguage = language
}
